export class Company {
  '@id'?: string;
  readonly name?: string;
  id?: number;
  logo: string;
  tokenOpenLog: string;
}
